module.exports = __webpack_public_path__ + "img/ledgers.closed.daily.3056fe49.png";